'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId from "./app.api.-Drug-Requests-Accepted-List-Item$-Id.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ as $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ };
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ as $h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ };
$h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$.prototype.toString__T = (function() {
  return "DrugRequest";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$.prototype.fromProduct__s_Product__Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest = (function(x$0) {
  var drugReqId$2 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId.$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest(drugReqId$2);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest(p);
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$, "app.api.DrugRequestsAcceptedListItem$Id$DrugRequest$", ({
  Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ as $d_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ };
var $n_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$;
function $m_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$() {
  if ((!$n_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$)) {
    $n_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ = new $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$();
  }
  return $n_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$;
}
export { $m_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ as $m_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest$ };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Id$-Drug-Request$.js.map
